// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2b_Dp","footer":"ModalFilter_footer__27mbO"};